import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiGet, apiPut } from 'app/shared-components/util/restAPI';

export const fetchOrganizationSettings = createAsyncThunk(
  'organizationSettings/fetchSettings',
  async (orgChannelId) => {
    const response = await apiGet('CoreAPI', `/channelentity/${orgChannelId}/organizationsettings`);
    return { orgChannelId, settings: response };
  }
);

export const updateOrganizationSettings = createAsyncThunk(
  'organizationSettings/updateSettings',
  async ({ orgChannelId, settings }) => {
    const options = {
      body: settings,
      headers: {},
      response: false
    };
    const response = await apiPut('CoreAPI', `/channelentity/${orgChannelId}/organizationsettings`, options);
    return { orgChannelId, settings: response };
  }
);

const organizationSettingsSlice = createSlice({
  name: 'organizationSettings',
  initialState: {
    settingsByOrgId: {},
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizationSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrganizationSettings.fulfilled, (state, action) => {
        state.loading = false;
        const { orgChannelId, settings } = action.payload;
        state.settingsByOrgId[orgChannelId] = settings;
      })
      .addCase(fetchOrganizationSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateOrganizationSettings.fulfilled, (state, action) => {
        const { orgChannelId, settings } = action.payload;
        state.settingsByOrgId[orgChannelId] = settings;
      });
  }
});

export const selectOrganizationSettings = (orgChannelId) => (state) => 
  state.organizationSettings.settingsByOrgId[orgChannelId] || null;

export const selectOrganizationSettingsLoading = (state) => 
  state.organizationSettings.loading;

export default organizationSettingsSlice.reducer;